import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { CalendarService } from './calendar.service';
import { CompanyService } from './company.service';
import { DeviceService } from './device.service';
import { EmployeeService } from './employee.service';
import { PostsService } from './posts.service';
import { UserService } from './user.service';
import { LoaderService } from './loader.service';
import { distinctUntilChanged } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataResetService {
  constructor(
    private readonly authService: AuthService,
    private readonly loaderService: LoaderService,
    private readonly calendarService: CalendarService,
    private readonly companyService: CompanyService,
    private readonly deviceService: DeviceService,
    private readonly employeeService: EmployeeService,
    private readonly postsService: PostsService,
    private readonly userService: UserService
  ) {
    this.authService.isLoggedIn$.subscribe((isLoggedIn) => {
      if (!isLoggedIn) {
        this.clearData();
      }
    });

    this.authService.companyChanged$.subscribe((companyId) => {
      this.clearCompanyData();
    });
  }

  clearCompanyData() {
    this.loaderService.showLoader();

    this.calendarService.clearData();
    this.companyService.clearData();
    this.deviceService.clearData();
    this.employeeService.clearData();
    this.postsService.clearData();

    this.loaderService.hideLoader();
  }

  clearData() {
    this.loaderService.showLoader();

    this.clearCompanyData();
    this.userService.clearData();

    this.loaderService.hideLoader();
  }
}
